'use client';

/**
 * WEB port of skillzapp `components/Countdown`: ticks every 1s, counting down to
 * `startsAt` while the event is upcoming, then to `endsAt` once it is live.
 * Same format tail — Xd Xh Xm / Xh Xm / Xm Xs / Xs — with single digits
 * zero-padded (`0$1`).
 */

import {useEffect, useState} from 'react';

function format(ms: number): string {
  if (ms <= 0) return '0s';
  const s = Math.floor(ms / 1000);
  const days = Math.floor(s / 86400);
  const hours = Math.floor((s % 86400) / 3600);
  const minutes = Math.floor((s % 3600) / 60);
  const seconds = s % 60;
  let str: string;
  if (days > 0) str = `${days}d ${hours}h ${minutes}m`;
  else if (hours > 0) str = `${hours}h ${minutes}m`;
  else if (minutes > 0) str = `${minutes}m ${seconds}s`;
  else str = `${seconds}s`;
  return str.replace(/\b(\d)\b/g, '0$1');
}

const remaining = (startsAt: string, endsAt: string): number => {
  const now = Date.now();
  const start = new Date(startsAt).getTime();
  const target = now < start ? start : new Date(endsAt).getTime();
  return target - now;
};

export default function LiveEventCountdown({startsAt, endsAt}: {startsAt: string; endsAt: string}) {
  const [label, setLabel] = useState(() => format(remaining(startsAt, endsAt)));
  useEffect(() => {
    const timer = setInterval(() => setLabel(format(remaining(startsAt, endsAt))), 1000);
    return () => clearInterval(timer);
  }, [startsAt, endsAt]);
  return <span>{label}</span>;
}
